import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../core/store';
import { Destroyable } from '../../../../core/util/destroyable';
import { AuthorizationMatrix } from '../../../../core/store/session/authorization/authorization.interface';
import { ContractInfo } from '../../../../core/store/contract-info/contract-info.interface';
import { goAction } from '../../../../core/store/router/router.actions';

@Component({
  selector: 'app-dashboard-flows-tile',
  templateUrl: './flows-tile.component.html',
  styleUrls: ['../common/orders-flows-tile.component.scss'],
})
export class FlowsTileComponent extends Destroyable implements OnChanges {
  @Input() authorization: AuthorizationMatrix;
  @Input() contractInfo: ContractInfo;
  showCreate = false;

  constructor(protected store: Store<fromRoot.RootState>) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.showCreate = this.authorization?.FLOW?.CREATE;
  }

  createFlowClicked() {
    this.store.dispatch(goAction({ path: `flows/new` }));
  }

  viewFlowsClicked() {
    this.store.dispatch(goAction({ path: `flows/execute-clean-filter` }));
  }

  viewOpenFlowsClicked() {
    this.store.dispatch(goAction({ path: `flows/openHandshakes` }));
  }

  viewDiffFlowsClicked() {
    this.store.dispatch(goAction({ path: `flows/diffHandshakes` }));
  }
}
